import { render, staticRenderFns } from "./BlogbookWord.vue?vue&type=template&id=4696d54e&scoped=true&"
import script from "./BlogbookWord.vue?vue&type=script&lang=js&"
export * from "./BlogbookWord.vue?vue&type=script&lang=js&"
import style0 from "./BlogbookWord.vue?vue&type=style&index=0&id=4696d54e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4696d54e",
  null
  
)

export default component.exports